import { useNavigate } from "react-router-dom";
import HeroVideo from "../../../assets/image/fieldsathi.mp4";
import TicketManagementImage from "../../../assets/image/features/3.png";
import "bootstrap/dist/css/bootstrap.min.css";

function Hero() {
  const navigate = useNavigate();

  return (
    <div className="container py-4">
      <div className="row align-items-center justify-content-center text-center text-md-start">
        <div className="col-md-6">
          <h1 className="fw-bold text-black  mb-3" style={{ fontSize: "40px" }}>
            CRM & Ticket Management
          </h1>
          <p className="text-muted small mb-3">
            A powerful solution for managing customer interactions, tracking
            support tickets, and streamlining field service processes. Automate
            workflows, improve team efficiency, and enhance customer
            satisfaction.
          </p>
          <button className="custom-button" onClick={() => navigate("/signin")}>
            Get Started
          </button>
        </div>

        <div className="col-md-6 d-none d-lg-block text-center">
          <video autoPlay loop muted playsInline className="w-100 rounded">
            <source src={HeroVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <div className="row align-items-center mt-4 p-3 bg-light rounded shadow-sm">
        <div className="col-md-6 text-center">
          <img
            src={TicketManagementImage}
            alt="Ticket Management"
            className="img-fluid rounded shadow-lg"
          />
        </div>
        <div className="col-md-6 text-center text-md-start ps-md-5">
          <h2 className="fw-bold text-black fs-2">
            Why Choose Our Ticket Management System?
          </h2>
          <ul className="text-muted small list-unstyled mt-3">
            <li className="mb-1">
              ✅ Track and manage support tickets efficiently.
            </li>
            <li className="mb-1">
              ✅ Assign, prioritize, and resolve tickets with ease.
            </li>
            <li className="mb-1">
              ✅ Automate workflows to improve response times.
            </li>
            <li className="mb-1">
              ✅ Get real-time insights with analytics and reporting.
            </li>
            <li className="mb-1">
              ✅ Enhance collaboration among teams and departments.
            </li>
          </ul>
          <button
            className="custom-button mt-2"
            onClick={() => navigate("/features")}
          >
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
}

export default Hero;
